import ApplicationController from '../application_controller'

class EventsController extends ApplicationController {
  connect () {
    document.addEventListener('calendar_ui:create_event', (e) => {
      const eventData = {
        calendar_event: {
          start_date: e.detail.start_date.format(),
          end_date: e.detail.end_date.format()
        }
      }

      $.ajax({
        url: '/calendar/events/new',
        type: 'GET',
        dataType: 'script',
        data: eventData
      }).done(this._onNewActionSuccess)
    })

    document.addEventListener('calendar_ui:edit_event', (e) => {
      $.ajax({
        url: e.detail.path + '/edit',
        type: 'GET',
        dataType: 'script'
      }).done(this._onNewActionSuccess)
    })
  }

  _onNewActionSuccess (_data) {
    hidden_side.open()
    hidden_side.contentElement.removeClass('loading')
  }
}

export default EventsController
